import { useState } from 'react';

export default function useProvideNotification() {
  const [notificationBanners, setNotificationBanners] = useState([]);
  // Bumps on every add - including a repeat of a banner already in the stack - so
  // consumers can react even when the stack contents don't change.
  const [bannerSignal, setBannerSignal] = useState(0);

  // newest notification at the top; a repeat of an existing banner moves back to the
  // top rather than being dropped
  const addNotificationBanner = banner => {
    setNotificationBanners(prev => [banner, ...prev.filter(({ text }) => text !== banner.text)]);
    setBannerSignal(signal => signal + 1);
  };

  return {
    setNotificationBanners,
    notificationBanners,
    addNotificationBanner,
    bannerSignal,
  };
}
